<template>
  <wui-modal
    class="w-[min(32.5rem,calc(100vw-32px))]!"
    :title="title"
    :size="40"
  >
    <p class="text-body-r-14-20 text-fg-base-fg10">
      {{ message }}
    </p>

    <template #footer>
      <wui-btn
        :size="40"
        variant="neut"
        state="alpha"
        data-test="close-false"
        @click="close(false)"
      >
        {{ cancelLabel || $t('common.no') }}
      </wui-btn>
      <wui-btn
        :size="40"
        variant="brand"
        state="filled"
        data-test="close-true"
        @click="close(true)"
      >
        <span>{{ confirmLabel || $t('common.yes') }}</span>
      </wui-btn>
    </template>
  </wui-modal>
</template>

<script setup lang="ts">
import { closeDialogKey, safeInject, WuiBtn, WuiModal } from '@wui/common-library'

defineProps<{
  title: string
  message: string
  confirmLabel?: string
  cancelLabel?: string
}>()

const closeModal = safeInject(closeDialogKey)

const close = (value: boolean) => {
  closeModal(value)
}
</script>
